<template>
    <div>
        <tab name="9"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <!-- <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.terminal" placeholder="请选择" size="small">
                        <el-option label="不限制下单终端" value=""></el-option>
                        <el-option v-for="(item,index) in terminalList" :key="index" :label="`仅看${item.name}的`" :value="item.code"></el-option>
                    </el-select>
                </el-col> -->
				<el-col :xs="24" :sm="12" :md="14" :lg="11" :xl="8">
				    <el-input v-model="params.searchValue" class="input-with-select" size="small">
				        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
				            <el-option label="演出ID" :value="1"></el-option>
				            <el-option label="演出名称" :value="2"></el-option>         
				        </el-select>
				    </el-input>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sort" placeholder="请选择" size="small">
                        <el-option label="优先展示销售总额最多的" :value="1"></el-option>
                        <el-option label="优先展示订单总数最多的" :value="2"></el-option>
                        <el-option label="优先展示售票总数最多的" :value="3"></el-option>
                        <el-option label="优先展示演出总数最多的" :value="4"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="14" :lg="11" :xl="8">                   
					<div class="clearfix timeType">
					    <el-input class="input-with-select fl" size="small">
					        <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
					            <el-option label="下单时间" :value="1"></el-option>
					        </el-select>
					    </el-input>
					    <el-date-picker
					        v-model="params.time"
					        type="datetimerange"
					        range-separator="-"
					        start-placeholder="开始时间"
					        end-placeholder="结束时间"
					        size="small"
					        value-format="yyyy-MM-dd HH:mm:ss"
					        :default-time="['00:00:00', '23:59:59']"
					        :clearable="false"
					        popper-class="el-date-picker_clearable"
					        style="width: 100%;"
					        unlink-panels
					        >
					    </el-date-picker>
					</div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <template v-if="statistics">
            <div class="page-group-title"><span>汇总统计</span></div>
            <el-card v-loading="fetchStatisticsLoading" shadow="never" class="statistics-box">
                <el-row :gutter="20">
                    <el-col :xs="12" :sm="6"><p class="num">{{statistics.amount || 0.00}}</p><p class="color-info">销售总额</p></el-col>
                    <el-col :xs="12" :sm="6"><p class="num">{{statistics.ticketNum || 0}}</p><p class="color-info">售票总数</p></el-col>
                    <el-col :xs="12" :sm="6"><p class="num">{{statistics.orderNum || 0}}</p><p class="color-info">订单总数</p></el-col>
                    <el-col :xs="12" :sm="6"><p class="num">{{statistics.activityNum || 0}}</p><p class="color-info">演出总数</p></el-col>
                </el-row>
            </el-card>
        </template>
        <div class="page-group-title"><span>统计列表</span></div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="terminalView" label="终端"></el-table-column>
                <el-table-column prop="amount" label="销售总额"></el-table-column>
                <el-table-column prop="totalNum" label="售票总数"></el-table-column>
                <el-table-column prop="orderNum" label="订单总数"></el-table-column>
                <el-table-column prop="activityNum" label="演出总数"></el-table-column>
                <el-table-column label="操作" fixed="right" :width="100">
                    <template slot-scope="scope">
                        <el-button v-if="$utils.have('/sales/terminal/data_list')" size="small" type="text" @click="toDate(scope.row)">查看日期明细</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import Tab from './../../components/tab';
import dayjs from 'dayjs';
import {fetchTerminal} from '@/assets/js/commonApi.js';
export default {
    components:{Tab},
    data(){
        const date = new Date();

        const month = date.getMonth();
        const day = date.getDate();

        const start = new Date();
        const end = new Date();

        start.setMonth(month - 3, day + 1);
        start.setHours(0, 0, 0);

        end.setHours(23, 59, 59);

        this.defaultParams = {
			searchType: 1,
			searchValue: '',
            queryType: 1,
            terminal: '',
            timeStart: dayjs(start).format('YYYY-MM-DD HH:mm:ss'),
            timeEnd: dayjs(end).format('YYYY-MM-DD HH:mm:ss'),
            sort: 1,
            pageNo: 1,
			timeType:1,
            pageSize: this.$pageSizes[0]
        };

        const params = this.parsing();

        return{
            statistics: null,
            fetchStatisticsLoading: false,
            data: null,
            dataList: null,
            params: {...params},
            listLoading: false,
            filter: null,
            // terminalList: [],
        }
    },
    created() {
        this.$router.replace({path: '/report/sales/terminal', query: {...this.$route.query, t: Date.now()}});
        // this.getTerminal();
        this.getStatistics();
    },
    watch: {
        '$route.query': function() {
            this.getDataList();
        }
    },
    methods:{
        parsing() {
            const {queryType, terminal, timeStart, timeEnd, sort, pageNo, pageSize,searchType,searchValue} = {...this.defaultParams, ...this.$route.query};

            return {
                queryType: parseInt(queryType), 
                terminal, 
                time: [timeStart, timeEnd], 
                sort: parseInt(sort), 
                pageNo: parseInt(pageNo), 
                pageSize: parseInt(pageSize),
				timeType:1,
				searchType: parseInt(searchType),
				searchValue: searchValue,
            };
        },
        //获取终端
        // getTerminal(){
        //     fetchTerminal()
        //     .then((res) => {
        //         const { state, result } = res.data;
        //         if (state == 1 && result) {
        //             this.terminalList =  result || [];
        //         } else {
        //             // this.$message.error(msg || "请求失败");
        //         }
        //     })
        // },
        //获取列表
        async getDataList() {
            const {time, ...params} = this.parsing();
            const [timeStart, timeEnd] = time || [];

            this.listLoading = true;

            const res = await this.$request({
                url: '/sales/terminal/list',
                method: 'post',
                data: {...params, timeStart, timeEnd}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.listLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.data = result;
            this.dataList = result || [];

            this.filter = {...params, timeStart, timeEnd};
        },
         //选择pageSize
         pageSizeChange() {
            if(this.isTimeError()) return;

            this.params.pageNo = 1;
            const {time, ...params} = this.params;
            const [timeStart, timeEnd] = time || [];
            this.$router.replace({path: '/report/sales/terminal', query: {...params, timeStart, timeEnd, t: Date.now()}});
        },
        pageNoChange() {
            if(this.isTimeError()) return;

            const {time, ...params} = this.params;
            const [timeStart, timeEnd] = time || [];
            this.$router.replace({path: '/report/sales/terminal', query: {...params, timeStart, timeEnd, t: Date.now()}});
        },
        //搜索
        search() {
            if(this.isTimeError()) return;
            
            this.params.pageNo = 1;
            const {time, ...params} = this.params;
            const [timeStart, timeEnd] = time || [];
            this.$router.replace({path: '/report/sales/terminal', query: {...params, timeStart, timeEnd, t: Date.now()}});
            this.getStatistics();
        },
        //重置搜索
        reset() {
            const {timeStart, timeEnd, ...params} = this.defaultParams;
            this.params = {
                ...params,
                time: [timeStart, timeEnd],
            };
            this.$router.replace({path: '/report/sales/terminal', query: {...params, timeStart, timeEnd, t: Date.now()}});
            this.getStatistics();
        },
        isTimeError() {
            const {time} = this.params;
            const [timeStart, timeEnd] = time || [];

            if(!timeStart || !timeEnd) {
                this.$alert('请选择时间范围', '提示', {confirmButtonText: '确认', type: 'warning', center: true});
                return true;
            }

            if(new Date(timeEnd).getTime() - new Date(timeStart).getTime() > 730 * 24 * 60 *60 *1000) {
                this.$alert('目前支持查询最多2年的数据', '提示', {confirmButtonText: '确认', type: 'warning', center: true});
                return true;
            }

            return false;
        },
        async getStatistics() {
            const {time, ...params} = this.params;
            const [timeStart, timeEnd] = time || [];


            this.fetchStatisticsLoading = true;

            const res = await this.$request({
                url: '/sales/terminal/statistics',
                method: 'post',
                data: {...params, timeStart, timeEnd}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.fetchStatisticsLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.statistics = result || {};
        },
        toDate(row) {
            const {terminal} = row;
            const {timeStart, timeEnd, searchType , searchValue} = this.filter;
            this.$router.push({path: '/report/sales/terminal/date', query: {terminal, timeStart, timeEnd, searchType , searchValue}});
        },
    }
}
</script>

<style lang="scss" scoped>
.statistics-box{
    margin: 20px 0;
    .el-col{
        text-align: center;
        padding: 8px 0;
        .num{
            font-size: 16px;
            margin-bottom: 5px;
        }
    }
}
</style>